<template>
	<div class="item-list" @click="$emit('click', $event)" :style="`cursor: ${cursor};`">
		<img :src="img" :style="`cursor: ${cursor};`" alt="text" :height="size">
		<span>{{ text }}</span>
	</div>
</template>

<script>
	export default {
		name: 'p-item-list',
		props: {
			img: String,
			size: [Number, String],
			text: {
				type: String,
				required: true,
			},
			cursor: {
				type: String,
				default: 'pointer',
			},
		},
	};
</script>

<style lang="scss" scoped>
.item-list {
	width: 100% !important;
	display: flex;
	justify-content: start;
	gap: 10px;
	align-items: center;
	color: color(gray-sidebar);
}
</style>


// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-item-list.vue